import { render, staticRenderFns } from "./ErrorMessages.vue?vue&type=template&id=20173eb8&"
import script from "./ErrorMessages.vue?vue&type=script&lang=ts&"
export * from "./ErrorMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VAlert,VCheckbox})
